'use client'

import { usePathname } from 'next/navigation'
import { type PropsWithChildren, type ReactNode } from 'react'

const QUESTIONNAIRE_PATHS = new Set([
  '/request-certificate/medical',
  '/request-certificate/medical-multiple-days',
  '/request-certificate/carer',
  '/request-certificate/carer-multiple-days',
])

type Props = PropsWithChildren<{
  footer: ReactNode
}>

export default function MedicalCertificateLayoutShell({
  children,
  footer,
}: Props) {
  const pathname = usePathname()
  const isQuestionnaire = QUESTIONNAIRE_PATHS.has(pathname)
  const isPaymentSuccess = pathname === '/request-certificate/success'
  const isVerification = pathname === '/verify-certificate'

  if (isQuestionnaire) {
    return <div className="bg-white pt-14">{children}</div>
  }

  if (isPaymentSuccess || isVerification) {
    return (
      <>
        <div className="bg-white pt-[66px] lg:pt-[86px]">{children}</div>
        {footer}
      </>
    )
  }

  return (
    <>
      <div className="bg-white pb-10 pt-14 sm:bg-slate-100 sm:pb-32">
        <div className="w-full">{children}</div>
      </div>
      {footer}
    </>
  )
}
